import { render, staticRenderFns } from "./ParallaxSimpleSection.vue?vue&type=template&id=5d633aca&scoped=true"
import script from "./ParallaxSimpleSection.vue?vue&type=script&lang=js"
export * from "./ParallaxSimpleSection.vue?vue&type=script&lang=js"
import style0 from "./ParallaxSimpleSection.vue?vue&type=style&index=0&id=5d633aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d633aca",
  null
  
)

export default component.exports